import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { S3UploadService } from 'gung-common';
import { S3Item, UserDetailsComponent, UsersService } from 'gung-standard';
import { catchError, concatMap, first, of, switchMap, throwError } from 'rxjs';
import { CarLinerFileUploadedService } from '../../services/car-liner-file-uploaded.service';

@Component({
    selector: 'car-liner-user-details',
    templateUrl: './car-liner-user-details.component.html',
    styleUrls: ['./car-liner-user-details.component.scss'],
    standalone: false
})
export class CarLinerUserDetailsComponent extends UserDetailsComponent {
  private s3UploadService = inject(S3UploadService)
  private carLinerFileUploadedService = inject(CarLinerFileUploadedService)
  isLoading: boolean;

  saveCurrentUser(): void {
    this.isLoading = true;
    const file = this.carLinerFileUploadedService.file;  
    const s3Upload$ = file
      ? this.s3UploadService.postImage(file).pipe(
          switchMap(image => {
            this.currentUser.extra.customLogo = image.s3Uri;
            this.isLoading = false;
            return this.usersService.updateUser(this.currentUser)
          })
        )
      : of(null);
  
    s3Upload$
      .pipe(
        concatMap(() => {
          this.isLoading = false;
          return this.usersService.updateUser(this.currentUser);
        }),
        first(),
        catchError((error) => {
          this.showError = true;
          this.errorMessage = error.error.message;
          this.isLoading = false;
          return throwError(error);
        })
      )
      .subscribe({
        next: (user) => {
          this.router.navigate(['/admin/manage-users'], {
            queryParamsHandling: 'preserve',
          });
          setTimeout(() => {
            window.location.reload();
            
          }, 250);
        },
      });
      
  }
  
  
  
}
